import styled from 'styled-components';

export const UploadBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  border: 2px dashed #fc6058;
  border-radius: 10px;
  padding: 8px;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(255, 0, 0, 0.05);
  }
`;

export const IconContainer = styled.div``;

export const UploadText = styled.p`
  margin: 4px 0;
  font-size: 14px;
  color: #525252;
  text-align: center;
`;

export const FileTypeText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #a3a3a3;
  text-align: center;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const PreviewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 200px;
  border-radius: 8px;
`;

export const RemoveButton = styled.button`
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: transparent;
  color: #da1e28;
  margin-top: 5px;
`;

export const FileListContainer = styled.div``;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
`;

export const FileIcon = styled.div`
  margin-right: 10px;
`;

export const FileName = styled.div`
  flex: 1;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileActions = styled.div`
  display: flex;
  align-items: center;
`;

export const ErrorMessage = styled.div`
  color: #ff0000;
  font-size: 12px;
  margin-top: 4px;
`;
export const Span = styled.span`
  color: #0055ff;
  font-size: 16px;
`;
